import { Button, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createAwardceremony } from "../../../../services/AwardceremonyService";

const validationSchema = Yup.object().shape({
  label: Yup.string().required("Required"),
  value: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
});

const AddAwardceremonyForm = () => {
  const initialValues = {
    label: "",
    value: "",
    description: "",
  };

  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    // Send the form data to the server
    try {
      await createAwardceremony(values);
      // Show success toast notification
      toast.success("Awardceremony added Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/awardceremonies");
      }, 3000);
      console.log("Awardceremony added successfully");

      // Optionally, redirect or update state after successful add
    } catch (error) {
      console.error("Error adding awardceremony:", error);
      toast.error("Failed to adding Award Ceremony!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col md={12}>
              <h4>Add Award Ceremony</h4>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched, isSubmitting, setFieldValue }) => (
                  <Form id="AwardCeremonyForm">
                    <Row className="mt-3 mb-3">
                      <Col md={4}>
                        <div controlId="label">
                          <label>Label</label>
                          <Field
                            type="text"
                            name="label"
                            className="form-control"
                            placeholder="Label"
                          />
                          {errors.label && touched.label && (
                            <div className="text-danger">{errors.label}</div>
                          )}
                        </div>
                      </Col>
                      <Col md={4}>
                        <div controlId="value">
                          <label>Value</label>
                          <Field
                            type="text"
                            name="value"
                            className="form-control"
                            placeholder="value"
                          />
                          {errors.value && touched.value && (
                            <div className="text-danger">{errors.value}</div>
                          )}
                        </div>
                      </Col>
                      <Col md={4}>
                        <div controlId="description">
                          <label>Description</label>
                          <Field
                            type="text"
                            name="description"
                            className="form-control"
                            placeholder="text"
                          />
                          {errors.description && touched.description && (
                            <div className="text-danger">
                              {errors.description}
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Button
                          style={{ background: "#3a7afe" }}
                          variant="primary"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          <i className="ti-save-alt" /> Save
                        </Button>
                        <Button
                          style={{
                            background: "#f25767",
                            border: "0px",
                            margin: "0.5rem",
                          }}
                          variant="warning"
                          href="/settings/awardceremonies"
                        >
                          <i className="fa fa-trash"></i>
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Card>
    </>
  );
};

export default AddAwardceremonyForm;
